export default "__VITE_ASSET__CjDnw$Qx__"